import React from 'react';
import './TurnTag.css';
import { Clock } from 'lucide-react';
import XhelosTooltip from '@components/ui/general/xhelos-tooltip/XhelosTooltip';

/**
 * TurnTag - Reusable component to display turn number with dynamic colors
 * Uses hero-badge style like StatusTag with colors matching game status
 *
 * @param {object} props
 * @param {number} props.turnNumber - The current turn number (required)
 * @param {string|object} props.status - The game status (for color variants)
 */
const TurnTag = ({ turnNumber, status }) => {
  // ✅ FAIL LOUDLY - Don't render if turnNumber is invalid
  if (!turnNumber || turnNumber <= 0) {
    return null;
  }

  // Clean status string (remove 'game_' prefix if present)
  const cleanStatus = status?.value ? status.value.replace('game_', '') : status?.replace('game_', '') || 'plan';

  return (
    <XhelosTooltip
      content={`Turn ${turnNumber}`}
      placement="top"
      theme="dark"
      trigger="hover"
    >
      <span className={`tag turn-tag turn-tag-${cleanStatus}`}>
        {turnNumber}
        <span className="turn-tag-icon">
          <Clock size={16} />
        </span>
      </span>
    </XhelosTooltip>
  );
};

export default TurnTag;
